import React from 'react'
import { useState } from 'react';
import { File } from "./File.js";
import "./FileSections.css";

export const FileSections = () => {
    const [mode, setMode] = useState(1)
    return (
        <div>
            <div id="mode_select2">
            <button id="uploadSec" onClick={()=>{setMode(1);}} style={{borderBottom: mode===1?"3px solid rgb(7, 101, 202)":"none", backgroundColor: mode===1?"rgb(41, 50, 65)":"rgb(25, 31, 41)"}}>Upload</button>
            <button id="downloadSec" onClick={()=>{setMode(0);}} style={{borderBottom: mode===0?"3px solid rgb(7, 101, 202)":"none", backgroundColor: mode===0?"rgb(41, 50, 65)":"rgb(25, 31, 41)"}}>Download</button>
            </div>
            <div id="home">
                {mode===0?<File download="true"/>:<File download="false"/>}
            </div>
        </div>
    )
}
